<template>
  <div class="flex flex-col items-center mb-10">
    <p class="text-base text-neutral-500">Version: {{ buildVersion }}</p>
  </div>
</template>
<script setup>
import { config } from "@/config";
const buildVersion = config.VERSION;
</script>
